import { FunctionComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import { styles } from '../../../../styles/themes/style'

const HomeHighlightsSyncingPrompt: FunctionComponent = () => (
    <Prompt>
        <PromptTitle>
            Syncing in progress
            <AnimatedDots aria-hidden>
                <Dot $delay={0} />
                <Dot $delay={0.2} />
                <Dot $delay={0.4} />
            </AnimatedDots>
        </PromptTitle>
    </Prompt>
)

const dotFade = keyframes`
    0%, 80%, 100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
`

const Prompt = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px 0 8px;
    text-align: center;
`

const PromptTitle = styled.p`
    margin: 0;
    display: inline-flex;
    align-items: center;
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    color: ${styles.colors.black600};
`

const AnimatedDots = styled.span`
    display: inline-flex;
    align-items: center;
    margin-left: 2px;
    height: 20px;
`

const Dot = styled.span<{ $delay: number }>`
    width: 4px;
    height: 4px;
    margin-left: 3px;
    border-radius: 50%;
    background: ${styles.colors.black600};
    opacity: 0;
    animation: ${dotFade} 1.2s ease-in-out infinite;
    animation-delay: ${({ $delay }) => `${$delay}s`};
`

export default HomeHighlightsSyncingPrompt
